import { render, staticRenderFns } from "./RelationImportOverview.vue?vue&type=template&id=18665849"
import script from "./RelationImportOverview.vue?vue&type=script&lang=js"
export * from "./RelationImportOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports